module.exports = __webpack_public_path__ + "static/media/dir-2.c3bf5ce1.jpeg";